import PropTypes from 'prop-types';
import { Tooltip, useMediaQuery, useTheme} from '@mui/material';
import { Button } from "@mui/material"
import { Save } from "lucide-react"
const SaveButton = ({ handleSave, updatedPages, disabled, t, dir }) => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
    const isTablet = useMediaQuery(theme.breakpoints.down("md"))
    const isRTL = dir === "rtl";
    return (
        <Tooltip title={t('save_changes')}>
            <span>
                <Button
                    onClick={handleSave}
                    disabled={disabled || updatedPages.length === 0}
                    startIcon={ <Save size={isMobile ? 10 : 12} /> }
                    sx={{
                        height: { xs: 28, sm: 32 },
                        width: { xs: 28, sm: 32 },
                        bgcolor: "transparent",
                        color: "#616161", // grey.700
                        border: "1px solid #BDBDBD", // grey.400
                        opacity: (disabled || updatedPages.length === 0) ? 0.5 : 1,
                        "&:hover": {
                            borderColor: "#757575", // grey.600
                            bgcolor: "#F5F5F5", // grey.100
                        },
                        "& .MuiButton-startIcon": {
                            marginLeft: isRTL ? "0.3rem" : "-4px",
                            marginRight: isRTL ? "0px" : "8px"
                        },
                    }}
                >
                    {t('save')}
                </Button>
            </span>
        </Tooltip>
    );
};

SaveButton.propTypes = {
    handleSave: PropTypes.func.isRequired,
    t: PropTypes.func,
    updatedPages: PropTypes.array.isRequired,
    disabled: PropTypes.bool,
    dir: PropTypes.string
};

export default SaveButton;
